import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './App.less';
import routes from './config/routes';
// import app from './services/AppService';
import {ConfigProvider } from 'antd';
import enUS from 'antd/es/locale/en_US';
import zhCN from 'antd/es/locale/zh_CN';
import thTH from 'antd/es/locale/th_TH';
import moment from 'moment';

import 'moment/locale/zh-cn';
import "moment/locale/en-au"
import "moment/locale/th";
import { api } from './util/axios';
import { initSysConfig } from './config';
import AuthLoading from './components/AuthLoading';
import {getLangName} from './config/lang';

const momentLocale = {
  "zh-CN":"zh-cn",
  "TAI":"th",
  "EN":"en-au"
}

const antdLocale = {
  "zh-CN":zhCN,
  "TAI":thTH,
  "EN":enUS
}
moment.locale(momentLocale[getLangName()]);

// app.run();


export default class App extends Component {


    state = {
      loading:false
    }

    loadConfig = ()=>{
      //api("config").get().then(ret=>initSysConfig(ret.data)).finally(()=>this.setState({loading:false}))
    }

    componentDidMount(){
      this.loadConfig();
    }
    
    render(){

      // console.log(process.env)

      if(this.state.loading){
         return <AuthLoading/>
      }


      return (     
        <ConfigProvider locale={antdLocale[getLangName()]}  >
          <HashRouter>
            <Switch>
              {routes.map((route, index) => {
                //console.log("route=>",route)
                return (
                  <Route
                    key={index}
                    path={route.path}
                    render={props=>{
                      const Page = route.component;
                      return Page? (
                         <Page {...props} reloadConfig={this.loadConfig} />
                      ):null
                    }}
                    // component={}
    
                  />
                )
              })}
            </Switch>
          </HashRouter>
        </ConfigProvider>
      );
    }

}
